import React, { useContext, useEffect, useState, useRef } from "react";
import "./SituacaoFiscal.scss";
import useLoading from "@hooks/useLoading";
import GlobalContext from "@context/GlobalContext";
import { useNavigate } from "react-router-dom";
import usePermissoes from "@hooks/usePermissoes";
import InputPesquisa from "@components/inputPesquisa/InputPesquisa";
import Button from "@components/button/Button";
import Cards from "@components/cards/Cards";
import BarChartMixed from "@components/graficos/barchartmixed/BarChartMixed";
import { BarChartColuna } from "@components/graficos/barchartcoluna/BarChartColuna";
import EndPointServices from "@services/ApiServices";
import UtilServices from "@services/UtilServices";
import { BarchartPie } from "@components/graficos/barchartpie/BarchartPie";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";

const SituacaoFiscal = () => {
  //State Padrões
  const [setLoading] = useLoading();
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();
  const { handlePermissoes } = usePermissoes();

  useEffect(() => {
    handleConsultarDashBoard();
  }, []);

  //DashBoard
  const [dadosCard, setDadosCard] = useState([]);
  const [dadosCard2, setDadosCard2] = useState([]);
  const [dadosGraficoColuna, setDadosGraficoColuna] = useState([]);
  const [dadosGraficoMixed, setDadosGraficoMixed] = useState([]);
  const [dadosGraficoPie, setDadosGraficoPie] = useState([]);

  //Dados
  const [dadosBkp, setDadosBkp] = useState([]);

  //Filtro
  const [lstkey, setLstKey] = useState([
    {
      id: 1,
      valor: "Razão Social",
      type: "text",
      mask: "",
      placeholder: "",
    },
    {
      id: 2,
      valor: "CNPJ",
      type: "text",
      mask: "",
      placeholder: "",
    },
  ]);
  const [retornoPesquisa, setRetornoPesquisa] = useState([]);
  const [clear, setClear] = useState(false);

  //Loading
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);

  //List
  const [listValue, setListValue] = useState([]);

  async function handleConsultarDashBoard() {
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
    };
    setLoading1(true);
    try {
      var retornoapi =
        await EndPointServices.ECAC_SituacaoFiscal_ConsultaDashBoard(data);
      if (retornoapi.Success) {
        console.log("retornoapi", retornoapi.BaseReturn.LstClasse);
        handleMontandoGrafico(retornoapi.BaseReturn.LstClasse);
        setDadosBkp(retornoapi.BaseReturn.LstClasse);
        setLoading1(false);
      }
    } catch (ex) {
      console.log(ex);
      setLoading1(false);
    }
  }
  function handleMontandoGrafico(dados) {
    //Pendência - Débito (SIEF)
    const totalDebito = dados.reduce((soma, item) => {
      const debito = item.TotalDebito;
      return soma + (typeof debito === "number" && debito > 0 ? debito : 0);
    }, 0);
    //Pendência - Débito (SIEF)
    const totalEmpresasComDebito = [
      ...new Set(
        dados
          .filter(
            (item) =>
              typeof item.TotalDebito === "number" && item.TotalDebito > 0,
          )
          .map((item) => item.ID_Empresa),
      ),
    ];
    //Pendência - Débito (SIEF)
    const totalGuiasVencidas = dados.reduce((soma, item) => {
      const count = item.TotalCount;
      return soma + (typeof count === "number" && count > 0 ? count : 0);
    }, 0);

    const totalEmpresasIrregulares = new Set(
      dados.filter((d) => d.ID_Pendencia > 0).map((d) => d.ID_Empresa),
    ).size;
    const totalEmpresasRegulares = new Set(
      dados.filter((d) => d.ID_Pendencia === 0).map((d) => d.ID_Empresa),
    ).size;
    const totalEmpresasExigibilidade = dados.filter((d) =>
      d.Tipo.toLowerCase().includes("exigibili"),
    ).length;

    const totalOmissoes = dados.filter((d) =>
      d.Tipo.toLowerCase().includes("omiss"),
    ).length;
    const totalEmpresasComOmissao = new Set(
      dados
        .filter((d) => d.Tipo?.toLowerCase().includes("omiss"))
        .map((d) => d.ID_Empresa),
    ).size;

    //Cards
    let Cards = [
      {
        key: "Empresas com Débitos",
        text: totalEmpresasComDebito.length,
      },
    ];
    setDadosCard(Cards);

    let Cards2 = [
      {
        key: "Empresas com Omissões",
        text: totalEmpresasComOmissao,
      },
      {
        key: "Omissões/Declarações",
        text: totalOmissoes,
      },
    ];
    setDadosCard2(Cards2);

    //Grafico de colunas.
    let GraficoColunas = [
      {
        key: "Irregulares",
        total: totalEmpresasIrregulares,
        fill: "var(--color-079)",
      },
      {
        key: "Regulares",
        total: totalEmpresasRegulares,
        fill: "#48844e",
      },
      // {
      //   key: "Sem Consultas a 30 dias",
      //   total: totalEmpresasSemConsultas,
      //   fill: "var(--color-021)",
      // },
      {
        key: "Exigibilidade Suspensa",
        total: totalEmpresasExigibilidade,
        fill: "#f3ff94",
      },
    ];
    setDadosGraficoColuna(GraficoColunas);

    //Graficos Mixed
    const graficoMixed = Object.entries(
      dados.reduce((acc, item) => {
        if (
          item.Tipo &&
          item.ID_Pendencia > 0 &&
          item.Tipo.toLowerCase().includes("omiss")
        ) {
          if (!acc[item.Tipo]) acc[item.Tipo] = new Set();
          acc[item.Tipo].add(item.ID_Empresa);
        }
        return acc;
      }, {}),
    ).map(([key, empresas]) => ({
      key,
      total: empresas.size,
      fill: "var(--color-079)",
    }));
    setDadosGraficoMixed(graficoMixed);

    //Grafico PIE
    let graficoPie = [
      {
        key: "Débitos",
        total: totalDebito,
        fill: "var(--color-079)",
      },
      {
        key: "Guias Vencidas",
        total: totalGuiasVencidas,
        fill: "var(--color-078)",
      },
    ];

    setDadosGraficoPie(graficoPie);
  }
  function handleFunctionKey(tp) {
    setLoading2(true);
    let lstvalue = [];

    //Razão Social
    if (tp.id === 1) {
      lstvalue = dadosBkp
        .map((e) => ({
          ID: e.ID_Empresa,
          valor: `${e.Razao_Social} ${
            e.ID_Pendencia !== 0 ? "(Pendência)" : ""
          }`,
        }))
        .filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.valor === item.valor),
        );
      //CNPJ
    } else if (tp.id === 2) {
      lstvalue = dadosBkp
        .map((e, index) => ({
          ID: e.ID_Empresa,
          valor: `${UtilServices.maskCNPJ(e.CNPJ)} ${
            e.ID_Pendencia !== 0 ? "(Pendência)" : ""
          }`,
        }))
        .filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.valor === item.valor),
        );
    }

    setListValue(lstvalue);
    setLoading2(false);
  }
  function handleFiltroGrafico() {
    let dadosFilter = dadosBkp;

    if (retornoPesquisa.length > 0) {
      const idsFiltro = retornoPesquisa.map((f) => f.valor.ID);
      dadosFilter = dadosBkp.filter((e) => idsFiltro.includes(e.ID_Empresa));
    }

    let resultado = { tipo: null, retornoPesquisa };
    dispatch({
      type: "SET_SITUACAOFISCAL",
      payload: resultado,
    });

    handleMontandoGrafico(dadosFilter);
  }
  function handleClickGrafico(dados) {
    let tipo = dados?.key ?? dados?.value;
    let resultado = { tipo: tipo, retornoPesquisa };

    dispatch({
      type: "SET_SITUACAOFISCAL",
      payload: resultado,
    });

    navigate("/ECAC/SituacaoFiscal/Analitico");
  }

  useEffect(() => {
    handleFiltroGrafico();
  }, [retornoPesquisa]);

  return (
    <div className="situacaofiscal container-fluid">
      <div className="pesquisas" style={{ marginTop: "35px" }}>
        <div style={{ position: "relative" }}>
          <InputPesquisa
            loading1={loading1}
            loading2={loading2}
            listKey={lstkey}
            listValue={listValue}
            handleFunctionKey={handleFunctionKey}
            handleFunctionPesquisa={handleFiltroGrafico}
            setRetorno={setRetornoPesquisa}
            clear={clear}
            setClear={setClear}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              position: "absolute",
              right: "5px",
              top: "0px",
            }}
          >
            <ButtonIcon
              Clear
              className="clear-icon"
              titleClear="Limpar os filtros"
              onClear={() => {
                setRetornoPesquisa([]);
                setClear(true);
              }}
            />
          </div>
        </div>
        <div className="relatorio-analitico">
          <i
            className="fa-solid fa-circle-exclamation"
            data-tooltip-id="tooltip-001"
            data-tooltip-content={
              "Os filtros aplicados no campo de busca serão usados no relatório analítico."
            }
          ></i>
          <Button
            theme="2"
            nome="Analitico"
            icon="<i class='fa-solid fa-file-chart-column'></i>"
            title="Relatorio Análitico"
            onClick={() => {
              navigate("/ECAC/SituacaoFiscal/Analitico");
            }}
            disabled={!handlePermissoes(3, "SituacaoFiscal", "Consultar")}
          />
        </div>
      </div>
      <div className="row" style={{ marginTop: "25px" }}>
        <div className="col-6">
          <div className="background-coluna">
            <p className="grafico-title" style={{ marginBottom: "56px" }}>
              Situação Fiscal
            </p>
            <BarChartColuna
              title={null}
              chartData={dadosGraficoColuna}
              dataKey="key"
              BarDataKey="total"
              functionClick={handleClickGrafico}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="background-pie">
            <p className="grafico-title">Débitos</p>
            <Cards lst={dadosCard} align="end" />
            <BarchartPie
              title={null}
              chartData={dadosGraficoPie}
              nameKey="key"
              dataKey="total"
              totalLegenda={false}
              label
              functionClick={handleClickGrafico}
            />
          </div>
        </div>
      </div>
      <div className="background-mixed">
        <p className="grafico-title">Omissões e Declarações</p>
        <Cards
          lst={dadosCard2}
          style={{ marginTop: "15px", marginBottom: "15px" }}
        />
        <BarChartMixed
          title={null}
          YDataKey="key"
          BarDataKey="total"
          chartData={dadosGraficoMixed}
          BarSize={25}
          functionClick={handleClickGrafico}
        />
      </div>
    </div>
  );
};

export default SituacaoFiscal;
